import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import { ClinicProvider } from '../../providers/clinic/clinic';

import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import * as XLSX from 'xlsx';
import { ProgramClinicsAddPage } from '../program-clinics-add/program-clinics-add';
import { Subject } from 'rxjs';

@IonicPage()
@Component({
  selector: 'page-program-clinics',
  templateUrl: 'program-clinics.html',
})
export class ProgramClinicsPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  program_name: string = null;
  program_id: string = null;
  exportjson: any[] = [];
  medications: any[] = [];
  displayedColumns = ['name', 'address', 'type', 'program_institution_id','fax_number', 'phone_number', 'main_contact','actions'];
  dataSource: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  
  constructor(
    public navCtrl: NavController, 
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public navParams: NavParams, 
    private auth: AuthProvider, 
    private dbProvider: ClinicProvider
    ) {
    this.auth.getCurrentUser().then(user => {
      this.program_name = user.program_name;
      this.program_id = user.program_id;

      const loading = this.loadingCtrl.create({});
      loading.present();

      this.dbProvider
      .listClinics(this.program_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((clinics) => {
        this.exportjson = clinics;
        this.dataSource = new MatTableDataSource(clinics);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        loading.dismiss();
      });
    });
  }

  ngOnDestroy() {
    console.log('Leave program clinics and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  export() {
    const workBook = XLSX.utils.book_new(); // create a new blank book
    const workSheet = XLSX.utils.json_to_sheet(this.exportjson);

    XLSX.utils.book_append_sheet(workBook, workSheet, 'Institutions'); // add the worksheet to the book
    XLSX.writeFile(workBook, 'institutions.xlsx'); // initiate a file download in browser
  }

  addeditClinic(clinic) {
    this.navCtrl.push(ProgramClinicsAddPage, {'clinicdata': clinic});
  }

  deleteClinic(clinic_id: string)  {
    //console.log('Delete Pharmacy: ', pharmacyId);
    let confirm = this.alertCtrl.create({
      title: "Delete Institution",
      message:
        "Are you sure you would like to delete this institution?",
      buttons: [
        {
          text: "No",
          handler: () => {}
        },
        {
          text: "Yes",
          handler: () => {
            this.dbProvider.deleteClinic(this.program_id, clinic_id).then(() => {
              //console.log('Successfully deleted the pharmacy');
            })
            .catch((error) => {
              //console.log('Error deleting pharmacy');
            });
          }
        }
      ]
    });
    confirm.present();
  }
}


// WEBPACK FOOTER //
// ./src/pages/program-clinics/program-clinics.ts